<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid" :style="extraStyle">
          <router-view />
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import api from '@/utils/api'
import consts from '@/utils/consts'
import Error from '@/mixin/error'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  mixins: [Error],
  data () {
    return {
      nav: nav.items,
      headHeight: 0,
      extraStyle: ''
    }
  },
  created () {
    this.$ajax.get(api.getConstants()).then((data) => {
      if (consts.ADMIN_TYPES.length === 1) {
        consts.ADMIN_TYPES.push(...data.admin_types)
      }
      if (consts.SERVICE_TYPES.length === 1) {
        consts.SERVICE_TYPES.push(...data.service_types)
      }
      if (consts.CATEGORY_TYPES.length === 1) {
        consts.CATEGORY_TYPES.push(...data.categorys)
      }
      if (consts.APP_STATUS.length === 1) {
        consts.APP_STATUS.push(...data.app_status)
      }
    }, (res) => {
      this.handleError(res)
    })
    this.$ajax.get(api.getAdminLoginInfo()).then((data) => {
      this.$store.dispatch('setUser', data.admin_info)
    }, (res) => {
      this.$store.dispatch('setUser', null)
    })
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      var matchRoute = this.$route.matched
      return matchRoute && matchRoute[1].name !== 'welcome' ? matchRoute : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// Full.vue?36b4c71c